(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["qdm-hero-slider"] && !Shopify.designMode) return;
  try {
    
  (function () {
    const AUTOPLAY_MS   = 5000;
    const TRANSITION_MS = 0.55; // segundos para GSAP

    function initSlider(section) {
      const root      = section.querySelector('[data-qdm-slider]') || section;
      const slides    = Array.from(root.querySelectorAll('[data-slide]'));
      const dots      = Array.from(root.querySelectorAll('[data-slider-dot]'));
      const prevBtn   = root.querySelector('[data-slider-prev]');
      const nextBtn   = root.querySelector('[data-slider-next]');
      const bar       = root.querySelector('[data-slider-bar]');
      const useGsap   = typeof gsap !== 'undefined';
      const REDUCED   = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

      if (slides.length === 0) return;

      let current      = 0;
      let isAnimating  = false;
      let progressTween = null;
      let autoTimer    = null;

      // Establece estado inicial visible del primer slide
      slides.forEach((slide, i) => {
        if (i !== 0 && useGsap) {
          gsap.set(slide, { opacity: 0, zIndex: 0 });
        }
      });

      function setDots(idx) {
        dots.forEach((d, i) => {
          d.classList.toggle('is-active', i === idx);
          d.setAttribute('aria-selected', i === idx ? 'true' : 'false');
        });
      }

      function startProgress() {
        if (!bar || REDUCED) return;
        if (progressTween) progressTween.kill();
        if (useGsap) {
          progressTween = gsap.fromTo(bar,
            { scaleX: 0 },
            {
              scaleX: 1,
              duration: AUTOPLAY_MS / 1000,
              ease: 'none',
              onComplete: () => goTo(current + 1)
            }
          );
        }
      }

      function stopProgress() {
        if (progressTween) progressTween.kill();
        clearTimeout(autoTimer);
      }

      function goTo(idx) {
        if (isAnimating) return;
        const total = slides.length;
        const next  = ((idx % total) + total) % total;
        if (next === current) return;

        isAnimating = true;
        stopProgress();

        const outSlide = slides[current];
        const inSlide  = slides[next];

        if (useGsap && !REDUCED) {
          const outEls = outSlide.querySelectorAll('[data-slider-el]');
          const inEls  = inSlide.querySelectorAll('[data-slider-el]');

          gsap.set(inSlide, { opacity: 0, zIndex: 1 });
          gsap.set(outSlide, { zIndex: 0 });

          const tl = gsap.timeline({
            onComplete: () => {
              outSlide.classList.remove('is-active');
              outSlide.setAttribute('aria-hidden', 'true');
              inSlide.classList.add('is-active');
              inSlide.setAttribute('aria-hidden', 'false');
              current = next;
              isAnimating = false;
              setDots(current);
              startProgress();
            }
          });

          // Fade out texto saliente
          tl.to(outEls, {
            opacity: 0,
            y: -12,
            duration: 0.25,
            ease: 'power2.in',
            stagger: 0.04
          });

          // Crossfade slide
          tl.to(inSlide, { opacity: 1, duration: TRANSITION_MS, ease: 'power2.inOut' }, '-=0.1');

          // Fade in texto entrante
          tl.fromTo(inEls,
            { opacity: 0, y: 20 },
            { opacity: 1, y: 0, duration: 0.5, ease: 'power2.out', stagger: 0.07 },
            '-=0.25'
          );

        } else {
          // Sin GSAP o reduced motion: cambio directo
          outSlide.classList.remove('is-active');
          outSlide.setAttribute('aria-hidden', 'true');
          inSlide.classList.add('is-active');
          inSlide.setAttribute('aria-hidden', 'false');
          current = next;
          isAnimating = false;
          setDots(current);
          startProgress();
        }
      }

      // Eventos
      if (prevBtn) prevBtn.addEventListener('click', () => goTo(current - 1));
      if (nextBtn) nextBtn.addEventListener('click', () => goTo(current + 1));

      dots.forEach(dot => {
        dot.addEventListener('click', () => goTo(parseInt(dot.dataset.sliderDot, 10)));
      });

      // Swipe en mobile
      let touchStartX = 0;
      root.addEventListener('touchstart', e => { touchStartX = e.changedTouches[0].clientX; }, { passive: true });
      root.addEventListener('touchend', e => {
        const delta = e.changedTouches[0].clientX - touchStartX;
        if (Math.abs(delta) > 50) goTo(current + (delta < 0 ? 1 : -1));
      }, { passive: true });

      // Pausar en hover
      root.addEventListener('mouseenter', stopProgress);
      root.addEventListener('mouseleave', startProgress);

      // Teclado
      root.addEventListener('keydown', e => {
        if (e.key === 'ArrowLeft')  goTo(current - 1);
        if (e.key === 'ArrowRight') goTo(current + 1);
      });

      // Arrancar
      setDots(0);
      startProgress();
    }

    function mountAll() {
      document.querySelectorAll('[data-qdm-slider]').forEach(el => {
        if (!el.dataset.sliderMounted) {
          el.dataset.sliderMounted = '1';
          initSlider(el);
        }
      });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', mountAll);
    } else {
      mountAll();
    }

    document.addEventListener('shopify:section:load', e => {
      const section = e.target;
      if (section.querySelector('[data-qdm-slider]')) {
        delete section.querySelector('[data-qdm-slider]').dataset.sliderMounted;
        initSlider(section.querySelector('[data-qdm-slider]'));
      }
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
